export default __webpack_public_path__ + "assets/4d281d1f4b8141a0d0b4f1b4d0606422.png";